import { APP_INITIALIZER, Provider } from '@angular/core';
import { DOMAIN_SUBSCRIBERS, CONSUMPTION_STORE } from '../../domain/tokens/consumption.token';
import { ConsumptionStoreSubscriber } from '../../application/subscribers/consumption.subscriber';
import { ConsumptionStore } from '../../application/store/consumption.store';

export const CONSUMPTION_PROVIDERS: Provider[] = [
  {
    provide: CONSUMPTION_STORE,
    useClass: ConsumptionStore
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ConsumptionStoreSubscriber,
    multi: true
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: () => () => {
    },
    deps: [ConsumptionStoreSubscriber]
  }
];
